export default "__VITE_ASSET__DjPPRukh__"